import { render, staticRenderFns } from "./SelectEnumNumber.vue?vue&type=template&id=46b961ea&scoped=true&"
import script from "./SelectEnumNumber.vue?vue&type=script&lang=js&"
export * from "./SelectEnumNumber.vue?vue&type=script&lang=js&"
import style0 from "./SelectEnumNumber.vue?vue&type=style&index=0&id=46b961ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b961ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
